module.exports = __webpack_public_path__ + "img/thumbnail_SpottedHyena_m_normal.408894d4.png";